import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Chip } from '#pplx/frontend/aether/components/Chip/index.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { memo, useCallback } from 'react';
export const SourceSuggestionButton = memo(function SourceSuggestionButton({ source, onClick, disabled, iconOnly = false }) {
    const { label, getIcon } = useSourceMeta({ sourceId: source });
    const handleClick = useCallback(() => {
        onClick(source);
    }, [onClick, source]);
    const SourceIcon = useCallback(() => getIcon('small'), [getIcon]);
    if (iconOnly) {
        return (_jsx(Button, { icon: SourceIcon, "aria-label": label ?? source, variant: "tonal", size: "small", rounded: true, disabled: disabled, onClick: handleClick, interactableVariant: "alt", track: false }));
    }
    return (_jsx(Chip, { label: label ?? source, leadingAccessory: getIcon(), variant: "suggestion", rounded: true, disabled: disabled, onClick: handleClick, interactableVariant: "alt" }));
});
//# sourceMappingURL=SourceSuggestionButton.js.map